module.exports = __webpack_public_path__ + "img/cjj3.6a69e35b.jpg";